"use client";

import { CampaignSummary } from "@decibeltrade/sdk";
import { type FetchQueryOptions, skipToken, useQuery } from "@tanstack/react-query";

import { readDexSdk } from "@/contexts/dex-sdk";

export const CAMPAIGN_SUMMARY_QUERY_KEY = "campaignSummary";

export interface CampaignSummaryQueryArgs {
  accountAddress: string | undefined;
}

export function campaignSummaryQueryKey({ accountAddress }: CampaignSummaryQueryArgs) {
  return [CAMPAIGN_SUMMARY_QUERY_KEY, accountAddress] as const;
}

export function campaignSummaryQuery({ accountAddress }: CampaignSummaryQueryArgs) {
  return {
    queryKey: campaignSummaryQueryKey({ accountAddress }),
    queryFn: !accountAddress
      ? skipToken
      : async () => readDexSdk.campaigns.getSummary({ accountAddress, limit: 200 }),
    staleTime: 30_000,
  } satisfies FetchQueryOptions<CampaignSummary>;
}

export function useCampaignSummaryQuery({ accountAddress }: CampaignSummaryQueryArgs) {
  return useQuery({
    ...campaignSummaryQuery({ accountAddress }),
    refetchInterval: 300_000,
  });
}
